<template>
  <tbody>
  <tr :class="['clickable', {disabled: !entity.provided,  updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td v-if="groupBySeries" :data-th="'Typ' | translate">
      {{ getType }} {{getEpisodesCount}}
    </td>
    <td v-if="!groupBySeries" :data-th="'Série a epizoda' | translate">
      {{ entity.season_and_episode_number }}
    </td>
    <td :data-th="'Věkové omezení' | translate">
      {{ maturityRatingText }}
    </td>
    <td :data-th="'Štítky' | translate">
      {{ tagNames }}
    </td>
    <td :data-th="'Státy' | translate">
      {{ countryNames }}
    </td>
    <td :data-th="'Poskytovatel videa' | translate">
      <entity-link :id="entity.id_vod_provider" type="vodProvider">{{ entity.vod_provider_name }}</entity-link>
    </td>
    <td :data-th="'Typ' | translate">
      {{ isSerie && groupBySeries ? '' : entity.vod_packages }}
    </td>
    <td :data-th="'Stav zpracování na zdroji' | translate">
      {{ isSerie && groupBySeries ? '' : getSourceStateText(entity.source_state) }}
    </td>
    <td :data-th="'Stav lokálního zpracování' | translate">
      {{ isSerie && groupBySeries ? '' : getLocalStateText(entity.local_state) }}
    </td>
    <td :data-th="'Délka' | translate">
      {{ isSerie && groupBySeries ? '' : $_formatMinutesToString(entity.duration_seconds/60) }}
    </td>
    <td :data-th="'Poskytováno od' | translate">
      {{ isSerie && groupBySeries ? '' : $_date_format(entity.provided_from) }}
    </td>
    <td :data-th="'Poskytováno do' | translate">
      {{ isSerie && groupBySeries ? '' : $_date_format(entity.provided_to) }}
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";
import date from "../../mixins/global/date";
import vodVideo from "./mixins/vodVideo";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "VodVideosRow",
  mixins: [rowActions, date, vodVideo],
  components: { EntityLink },
  props: {
    entity: Object,
    groupBySeries:Boolean,
    tags: Object,
    countries: Object,
  },
  data(){
    return{
      detailPageRouteName: "vodVideosDetail",
    }
  },
  computed: {
    maturityRatingText(){
      let result = this.entity.maturity_rating;
      if(result === 'Všechny věkové kategorie'){
        result = this.$gettext('Všechny věkové kategorie');
      }

      return result;
    },
    isSerie(){
      return this.entity.is_serial;
    },
    getType(){
      return this.isSerie ? this.$gettext('Série') : this.$gettext('Film');
    },
    getEpisodesCount(){
      if(this.isSerie){
        let episodeText = "";
        if(this.entity.episodes_count < 2){
          episodeText =this.$gettext('Epizoda');
        }else if(this.entity.episodes_count < 5){
          episodeText = this.$gettext('Epizody');
        }else{
          episodeText = this.$gettext('Epizod');
        }
        return ' - '+this.entity.episodes_count+' '+episodeText;
      }else{
        return '';
      }
    },
    tagNames(){
      let tagNames = [];
      if(this.entity.tag_ids){
        this.entity.tag_ids.forEach((item) => {
          if(this.tags.hasOwnProperty(item)){
            tagNames.push(this.tags[item]);
          }
        });
      }
      return tagNames.join(', ');
    },
    countryNames(){
      let countryNames = [];
      if(this.entity.country_ids){
        this.entity.country_ids.forEach((item) => {
          if(this.countries.hasOwnProperty(item)){
            countryNames.push(this.countries[item]);
          }
        });
      }
      return countryNames.join(', ');
    }
  },
  methods: {
    goToDetail(e, entity) {
      if(this.groupBySeries && this.isSerie){
        this.$router.push({name: 'vodEpisodes', params: {id: entity.id_show}})
      }else {
        this.$router.push({name: this.detailPageRouteName, params: {id: entity.id}})
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodVideos/VodVideosRow.vue